function DefaultLoading() {
    return (
        <div className="loading">
            <p>Loading...</p>
        </div>
    );
}

export default DefaultLoading;